import i18next from 'i18next';
import { getConfig } from '../services/configService';

export const MAIN_SITE_ORIGIN = 'https://camelstep.com';

/**
 * Public marketing/home site (camelstep.com), not the current app origin.
 */
export const getMainSiteUrl = (path = '/') => {
  const lang = i18next.language || 'ar';
  const origin = (getConfig().homepageUrl || MAIN_SITE_ORIGIN).replace(/\/$/, '');
  const normalized = path.startsWith('/') ? path : `/${path}`;

  if (normalized === '/') {
    return `${origin}/${lang}/`;
  }

  return `${origin}/${lang}${normalized}`;
};
